import { Result } from 'antd';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { BaseButton } from '../../../components/base-button/BaseButton';
import { setLoadingPageGlobal } from '../../../redux/globalReducer';
import { DEFAULT_PAGE } from '../../../utils/constants/AppConstants';
import { Ii18n } from '../../../utils/interfaces/i18n';

const NotExits = () => {
  const { t }: Ii18n = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLoadingPageGlobal(false));
  }, []);

  // function redirect to the login page
  const goBackHome = () => {
    window.location.href = DEFAULT_PAGE;
  };

  return (
    <div className='flex items-center h-[100vh]'>
      <Result
        status='404'
        title='404'
        subTitle={t('page_not_found:announce')}
        extra={
          <div className='w-full flex items-center justify-center'>
            <BaseButton type='primary' size='large' onClick={goBackHome}>
              {t('page_not_found:back_home')}
            </BaseButton>
          </div>
        }
        className='m-auto'
      />
    </div>
  );
};

export default NotExits;
